import type { ModuleMigrationDef } from "@kubdee/sdk";

// ============================================================================
// 002_customers — Doctype Admin Epic (#347) issue C1 (#359).
//
// Creates `crm_customers`, the master-data pilot for the doctype registry.
// Mirrors the "transactional pilot" in B1 (`sales_quotations.custom_data`)
// but on a master-data shape.
//
// Shape contract (enforced at the form layer by `buildCustomFieldSchema` —
// A7 helper, lives in `modules/core/services/custom-field-schema.ts`):
//   custom_data IS NULL                       → no custom fields set
//   custom_data = '{ "field_a": ..., ... }'   → field_name → primitive value
// Callers MUST read this column via `parseCustomData` so malformed blobs on
// older rows return `{}` instead of throwing.
//
// Safety:
//   - `IF NOT EXISTS` is used on the CREATE TABLE so re-runs on a tenant
//     that already has the table (e.g. manual backfill) are idempotent.
//   - `custom_data` is nullable with no DEFAULT; rows created before C2
//     wires the form just land NULL, not `{}`. The parse helper treats
//     NULL as "no custom data" without allocating an object.
//   - No FKs to accounting_partners because this CRM-owned table is an
//     independent master record. Cross-module linkage stays at the
//     `routes/` layer (public-api pattern) where it belongs.
//   - CREATE INDEX IF NOT EXISTS — survives replay on a seeded tenant.
//   - Idempotence is additionally delegated to the upstream
//     `module_migration_log` used by `runModuleMigrations`, which skips
//     any migration whose `key` is already recorded `completed` for this
//     company. First attempt is authoritative.
// ============================================================================
export const migration: ModuleMigrationDef = {
  key: "002_customers",
  version: "1.0.0",
  sql: `
CREATE TABLE IF NOT EXISTS \`crm_customers\` (
  \`id\` text PRIMARY KEY NOT NULL,
  \`company_id\` text NOT NULL,
  \`name\` text NOT NULL,
  \`custom_data\` text,
  \`created_at\` text NOT NULL,
  \`created_by\` text,
  \`updated_at\` text NOT NULL,
  \`updated_by\` text,
  \`deleted_at\` text,
  \`deleted_by\` text
);
CREATE INDEX IF NOT EXISTS \`crm_customer_company_idx\` ON \`crm_customers\` (\`company_id\`);
  `.trim(),
};
